const REST_COUNTRIES_API_BASE_URL = "https://restcountries.com/v3.1";

export const REST_COUNTRIES_API_ALL_URL = `${REST_COUNTRIES_API_BASE_URL}/all`;

export const REST_COUNTRIES_API_ALPHA_URL = `${REST_COUNTRIES_API_BASE_URL}/alpha`;
